module.exports = __webpack_public_path__ + "static/media/29-7.2e891959.mp3";